import { render, staticRenderFns } from "./centerChartRate.vue?vue&type=template&id=704da120&scoped=true&"
import script from "./centerChartRate.vue?vue&type=script&lang=js&"
export * from "./centerChartRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704da120",
  null
  
)

export default component.exports